<template>

    <div class="px-6 py-4 bg-minplan-beige -mb-4">
        <page-title :title="$t('apartments.newBuyer')"></page-title>
    </div>

    <jet-form-section @submitted="createBuyer()">

        <template #form>

            <!-- Card Apartment Information -->
            <form-card :title="$t('apartments.buyer')" :description="$t('apartments.buyerDescription')">
                <BuyerFormFields :form="form" mode="create" />
            </form-card>

        </template>

        <template #actions>
            <div class="flex justify-end my-4 mx-6">

                <button @click="cancel" type="button" class="inline-block uppercase font-semibold text-xs tracking-widest">
                    {{ $t("actions.cancel") }}
                </button>

                <primary-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="ml-3 ">
                    {{ $t("actions.save") }}
                </primary-button>

            </div>
        </template>

    </jet-form-section>

</template>


<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import PageTitle from "@/Shared/Components/PageTitle";
import { useForm } from "@inertiajs/inertia-vue3";
import FormCard from "@/Shared/Components/FormCard";
import BuyerFormFields from "@/Shared/Components/Buyers/BuyerFormFields.vue";

export default defineComponent({
    props: ["apartment"],
    inheritAttrs: false,
    layout: MainLayout,
    emits: ["closeModal"],
    components: {
        PageTitle,
        PrimaryButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        FormCard,
        BuyerFormFields
    },
    methods: {
        cancel() {
            this.$emit("closeModal");
        },
        createBuyer() {
            this.form.post(this.route("advisors.apartments.store.buyer", this.apartment.uuid), {
                preserveScroll: true,
                onSuccess: () => this.$notify({
                    group: "success",
                    title: 'actions.success',
                    text: 'apartments.buyerCreated'
                })
            });
        }
    },
    setup() {


        const form = useForm({
            firstname: null,
            lastname: null,
            street: null,
            zip: null,
            city: null,
            phone: null,
            email: null,
            notify: true,
            invite: false,
            country: null
        });

        return { form };
    }
});
</script>

<style scoped></style>
